import * as bootstrap from 'bootstrap';
import { formatCurrency } from '../functions';
export default class ArenaGUI {
    constructor() {
        this.init();
    }

    init() {
        const toggleBtn = document.getElementById('panelToggleBtn');
        const content = document.getElementById('panelContent');
        const seatsContainer = document.querySelector('.seats');
        if (!toggleBtn || !content || !seatsContainer) return;

        const tooltip = new bootstrap.Tooltip(toggleBtn, {
            trigger: 'manual', // manual control, no hover/focus triggers
        });
        if (tooltip) {
            tooltip.show();
        }

        //Functions
        function updateTicketCountAndSum() {
            const seatRows = document.querySelectorAll('.seats .seat');
            let ticketCount = seatRows.length;
            let sum = 0;

            seatRows.forEach(row => {
                const priceSpan = row.querySelector('td .price-value');
                if (!priceSpan) return;

                const priceAttr = priceSpan.dataset.price;
                const price = parseFloat(priceAttr);

                if (!isNaN(price)) sum += price;
            });

            const ticketCountSvg = document.getElementById('ticketCountIconText');
            ticketCountSvg.textContent = ticketCount;
            if (ticketCount <= 0) {
                var sumContainer = document.getElementById('ticketSumContainer');
                if (sumContainer) {
                    sumContainer.classList.remove('d-flex');
                    sumContainer.classList.add('d-none');
                }
            }
            const sumElement = document.getElementById("ticketSumTotal");
            if (sumElement) {
                sumElement.textContent = formatCurrency(sum);
            }
        }
        function updateFade() {
            const clientH = content.clientHeight;
            const scrollH = content.scrollHeight;
            const scrollT = content.scrollTop;

            if (scrollH > clientH + 1 && scrollT + clientH < scrollH - 1) {
                content.classList.add('has-more');
            } else {
                content.classList.remove('has-more');
            }
        }

        //Events
        content.addEventListener('scroll', updateFade);
        toggleBtn.addEventListener('click', () => {
            const isOpen = content.classList.toggle('open');
            if (isOpen) {
                // Wait for CSS transition to finish (max-height animation)
                const onTransitionEnd = (e) => {
                    if (e.propertyName === 'max-height') {
                        updateFade();
                        content.removeEventListener('transitionend', onTransitionEnd);
                    }
                };
                content.addEventListener('transitionend', onTransitionEnd);
            } else {
                content.classList.remove('has-more');
            }

            const tooltip = bootstrap.Tooltip.getInstance(toggleBtn);
            if (tooltip) {
                tooltip.hide();
                tooltip.disable();
            }
        });
        const observer = new MutationObserver(() => {
            updateTicketCountAndSum();
            updateFade();
        });
        observer.observe(seatsContainer, { childList: true, subtree: true });

    }
}